<app-edit-note [breadCrumbInputs]="breadCrumbInputs"></app-edit-note>